import React, { useEffect } from 'react';
import useOperationalStore from '../store/useOperationalStore';
import GlobalHeader from './GlobalHeader';
import EdgePanel from './EdgePanel';
import RODetailPanel from './RODetailPanel';
import './PlatformShell.css';

export default function PlatformShell({
  customerCheckIns,
  onManageTechs,
  onAddTruck,
  children,
}) {
  const fetchAll           = useOperationalStore(s => s.fetchAll);
  const startSubscriptions = useOperationalStore(s => s.startSubscriptions);
  const stopSubscriptions  = useOperationalStore(s => s.stopSubscriptions);
  const setActiveView      = useOperationalStore(s => s.setActiveView);
  const isViewFullscreen   = useOperationalStore(s => s.isViewFullscreen);
  const setViewFullscreen  = useOperationalStore(s => s.setViewFullscreen);

  useEffect(() => {
    fetchAll();
    startSubscriptions();
    const refreshQuietly = () => fetchAll({ quiet: true });
    const interval = setInterval(refreshQuietly, 5000);
    window.addEventListener('focus', refreshQuietly);
    const params = new URLSearchParams(window.location.search);
    const view = params.get('view');
    if (view) setActiveView(view);
    // Reset fullscreen state if browser exits fullscreen (e.g. Esc key)
    const onFsChange = () => {
      if (!document.fullscreenElement) setViewFullscreen(false);
    };
    document.addEventListener('fullscreenchange', onFsChange);

    return () => {
      clearInterval(interval);
      window.removeEventListener('focus', refreshQuietly);
      document.removeEventListener('fullscreenchange', onFsChange);
      stopSubscriptions();
    };
  }, []);

  return (
    <div className={`platform-shell${isViewFullscreen ? ' platform-shell--fs' : ''}`}>
      {/* No sidebar — the header IS the nav (5 workspaces, frozen) */}
      <div className="platform-content">
        <GlobalHeader
          customerCheckIns={customerCheckIns}
          onManageTechs={onManageTechs}
          onAddTruck={onAddTruck}
        />
        <div className="platform-body">
          <main className="platform-main">
            {children}
          </main>
          <RODetailPanel />
        </div>
      </div>

      {/* Fullscreen-only quick nav (renders nothing outside fullscreen) */}
      <EdgePanel />
    </div>
  );
}
